<template>
  <v-container class="grey lighten-5">
    <div class="error">
      <div class="container-floud">
        <div class="col-xs-12 ground-color text-center">
          <div class="container-error-404">
            <div class="clip"><div class="shadow"><span class="digit thirdDigit">4</span></div></div>
            <div class="clip"><div class="shadow"><span class="digit secondDigit">0</span></div></div>
            <div class="clip"><div class="shadow"><span class="digit firstDigit">4</span></div></div>
            <div class="msg">OH!<span class="triangle"></span></div>
          </div>
          <h2 class="h1">Sorry! Page not found</h2>
        </div>
      </div>
    </div>
    <div class="text-caption d-flex justify-space-around flex-md-row">
      <v-btn color="blue" @click="$router.go(-1)"> Go Back</v-btn>
    </div>
  </v-container>
</template>


<script>
import "@/assets/scss/error.scss"
export default {
  name: 'NotFound',

  data: () => ({
    breadcrumbs: [
      {
        text: 'Dashboard',
        disabled: false,
        to: '/dashboard',
      },
      {
        text: '404',
        disabled: true,
      }
    ],
  }),

  mounted() {

  }
}
</script>